// src/pages/approval/LeaveDetailModal.jsx
// ✅ 휴가신청서 상세(미리보기·인쇄) 모달 — 휴가신청 목록·수신참조 목록이 같이 쓴다(2026-10-19).
import React, { useEffect, useState } from "react";
import api from "../../api";
import useBackdropClose from "../../hooks/useBackdropClose";
import LeaveRequestPreview, { buildLeaveRequestProps } from "../../components/preview/leave/LeaveRequestPreview";
import styles from "./LeaveRequest.module.css";

export default function LeaveDetailModal({ documentId, onClose }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState("");
  const backdrop = useBackdropClose(onClose);

  useEffect(() => {
    let cancelled = false;
    setDoc(null);
    setError("");
    api.get(`/draft/leave-requests/${documentId}/`)
      .then(({ data }) => !cancelled && setDoc(data))
      .catch((err) => !cancelled && setError(err.response?.data?.error || "불러오지 못했습니다."));
    return () => { cancelled = true; };
  }, [documentId]);

  return (
    <div className={styles.overlay} {...backdrop}>
      <div className={styles.modal}>
        <div className={styles.modalHead}>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">✕</button>
        </div>
        {error && <div className={styles.error}>{error}</div>}
        {!doc && !error && <div className={styles.empty}>불러오는 중...</div>}
        {doc && <LeaveRequestPreview {...buildLeaveRequestProps(doc)} />}
      </div>
    </div>
  );
}
